module.exports = __webpack_public_path__ + "img/tips.e0698295.jpg";